module.exports = __webpack_public_path__ + "img/image26.b0262754.png";